<template lang="pug">
  .first-access-success.mt-3
    v-layout(
      justify-center
      align-center
      wrap
    )
      v-flex(xs12).text-xs-center.mt-3
        v-icon().check-icon check_circle_outline
      v-flex(xs12).mt-3.message {{ $t('app.login.firstAccessSuccess.message') }}
      v-flex(xs12).mt-3
        btn-primary(
          block
          @click="navigateTo('Login')"
          :text="$t('app.login.firstAccessSuccess.enter')"
        )
</template>

<script>
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';
import PageableMixin from 'Support/components/lists/mixins/pageable.mixin';

export default {
  name: 'FirstAccessSuccess',
  components: {
    BtnPrimary,
  },
  mixins: [PageableMixin],
};
</script>


<style lang="stylus" scoped>
  .first-access-success
    .check-icon
      color #00BD00
      font-size 48px
    .message
      font-style normal
      font-weight normal
      font-size 16px
      text-align center
      letter-spacing 0.2px
      color #c33c3c
</style>
